import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Cookieを使用しています',
    description:
      'このエクスペリエンスを提供するために、Cookie と類似の技術を使用しています。厳密に必要な Cookie は常に有効です。',
    allow_label: 'すべての Cookie を許可',
    reject_label: '厳密に必要な Cookie のみ',
    settings_label: 'Cookie の設定',
    policy_link_label: 'プライバシーおよび Cookie ポリシー',
    categories_label: 'カテゴリー',
    always_on_label: '常に有効',
    required_label: '必須',
    save_preferences_label: '設定を保存',
    close_label: '閉じる',
    allow_all_optional_categories_label: 'すべての任意カテゴリーを許可',
    settings_title: 'Cookie の設定',
    settings_description:
      'このエクスペリエンスを提供するために、Cookie と類似の技術を使用しています。厳密に必要な Cookie は常に有効です。',
    save_error: 'プライバシー設定を保存できませんでした。もう一度お試しください。'
  },
  categories: {
    strictly_necessary: {
      name: '厳密に必要',
      purpose: 'このエクスペリエンスの提供に必要であり、無効にすることはできません。'
    },
    analytics: { name: '分析', purpose: 'パフォーマンス向上のため、訪問者による利用状況を測定します。' },
    marketing: { name: 'マーケティング', purpose: '主催者が選択した広告とマーケティングをサポートします。' }
  }
};

export default locale;
